import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import MyApiClient from "../../../api-client/MyApiClient";

const langOptions = [
    { value: "ar", label: "Arabo" },
    { value: "de", label: "Tedesco" },
    { value: "en", label: "Inglese" },
    { value: "it", label: "Italiano" },
    { value: "es", label: "Spagnolo" },
    { value: "fr", label: "Francese" },
    { value: "ru", label: "Russo" },
];

const emptyForm = {
    givenName: '', familyName: '', birthdate: '', gender: '',
    nationality: '', fiscalCode: '', description: '', streetAddress: '', locality: '',
    country: '', postalCode: '', province: '', languagesLabel: '',
};

// Campo in sola lettura (label + input non modificabile, stile grigio chiaro)
const ReadOnlyField = ({ label, value, type = 'text' }) => (
    <Form.Group className="mb-3">
        <Form.Label>{label}</Form.Label>
        <Form.Control className="sid-ro-input" type={type} value={value || ''} readOnly tabIndex={-1} />
    </Form.Group>
);

const DatiAnagraficiPlayer = (props) => {
    const [form, setForm] = useState(emptyForm);
    // Dati di fatturazione che il player ha indicato alla struttura: sono suoi,
    // stanno su una chiamata a parte e non nel profilo anagrafico.
    const [fatturazione, setFatturazione] = useState(null);
    const [fatturazioneLetta, setFatturazioneLetta] = useState(false);

    const playerId = props.playerId || (props.profile && props.profile.idsPlay && props.profile.idsPlay.userId);

    useEffect(() => {
        if (!playerId) return;
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return;
        const token = JSON.parse(tokenDetailsString).idToken;
        let annullato = false;

        new MyApiClient().getClubPlayerInvoiceDataReceiver(token, playerId)
            .then(dati => {
                if (annullato) return;
                setFatturazione(dati && !dati.error ? dati : null);
                setFatturazioneLetta(true);
            })
            .catch(errore => {
                console.error('Dati di fatturazione del player non letti', errore);
                if (!annullato) setFatturazioneLetta(true);
            });

        return () => { annullato = true; };
    }, [playerId]);

    useEffect(() => {
        const p = props.profile && props.profile.idsPlay;
        if (!p) return;

        const address = p.address || {};
        let languagesLabel = '';
        if (Array.isArray(p.spokenLocales)) {
            languagesLabel = p.spokenLocales
                .map((v) => (langOptions.find((o) => o.value === v) || {}).label)
                .filter(Boolean)
                .join(', ');
        }

        setForm({
            givenName: p.givenName || '',
            familyName: p.familyName || '',
            birthdate: p.birthdate || '', // yyyy-MM-dd
            gender: p.gender || '',
            nationality: p.nationality || '',
            fiscalCode: p.taxCode || '',
            description: p.description || '',
            streetAddress: address.streetAddress || '',
            locality: address.locality || '',
            country: address.country || '',
            postalCode: address.postalCode || '',
            province: address.province || '',
            languagesLabel,
        });
    }, [props.profile]);

    const genderLabel = form.gender
        ? (form.gender.toUpperCase().startsWith('M') ? 'Maschio' : form.gender.toUpperCase().startsWith('F') ? 'Femmina' : form.gender)
        : '';
    const countryLabel = form.country === 'IT' ? 'Italia' : form.country;
    const azienda = fatturazione && fatturazione.type === 'business';

    return (
        <Row>
            <Col lg={6}>
                <Card>
                    <Card.Header><Card.Title>Dati anagrafici</Card.Title></Card.Header>
                    <Card.Body>
                        <ReadOnlyField label="Nome" value={form.givenName} />
                        <ReadOnlyField label="Cognome" value={form.familyName} />
                        <ReadOnlyField label="Data di nascita" value={form.birthdate} type="date" />
                        <ReadOnlyField label="Sesso" value={genderLabel} />
                        <ReadOnlyField label="Nazionalità" value={form.nationality} />
                        <ReadOnlyField label="Codice Fiscale" value={form.fiscalCode} />
                        <ReadOnlyField label="Indirizzo" value={form.streetAddress} />
                        <ReadOnlyField label="Località" value={form.locality} />
                        <ReadOnlyField label="Provincia" value={form.province} />
                        <ReadOnlyField label="CAP" value={form.postalCode} />
                        <ReadOnlyField label="Paese" value={countryLabel} />
                    </Card.Body>
                </Card>
            </Col>
            <Col lg={6}>
                {/* Email e telefono stanno gia' nell'intestazione, sotto il nome: qui
                    erano la stessa cosa scritta due volte. */}
                <Card>
                    <Card.Header><Card.Title>Altri dati</Card.Title></Card.Header>
                    <Card.Body>
                        <ReadOnlyField label="Lingue parlate" value={form.languagesLabel} />
                        <Form.Group className="mb-0">
                            <Form.Label>Descrizione</Form.Label>
                            <Form.Control className="sid-ro-input" as="textarea" rows={3} value={form.description} readOnly tabIndex={-1} />
                        </Form.Group>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Header><Card.Title>Dati di fatturazione</Card.Title></Card.Header>
                    <Card.Body>
                        {fatturazione ? (
                            <>
                                <ReadOnlyField label="Intestatario" value={azienda ? 'Azienda' : 'Privato'} />
                                {azienda ? (
                                    <>
                                        <ReadOnlyField label="Ragione sociale" value={fatturazione.denomination} />
                                        <ReadOnlyField label="Partita IVA" value={fatturazione.vat_number} />
                                        <ReadOnlyField label="Codice destinatario" value={fatturazione.sdi_code} />
                                    </>
                                ) : (
                                    <>
                                        <ReadOnlyField label="Nome" value={fatturazione.first_name} />
                                        <ReadOnlyField label="Cognome" value={fatturazione.last_name} />
                                    </>
                                )}
                                <ReadOnlyField label="Codice Fiscale" value={fatturazione.tax_code} />
                                <ReadOnlyField label="PEC" value={fatturazione.pec} />
                                <ReadOnlyField label="Indirizzo" value={fatturazione.address} />
                                <ReadOnlyField label="Città" value={fatturazione.city} />
                                <ReadOnlyField label="Provincia" value={fatturazione.province} />
                                <ReadOnlyField label="CAP" value={fatturazione.zip_code} />
                            </>
                        ) : (
                            <p className="mb-0 text-muted">
                                {fatturazioneLetta
                                    ? 'Il player non ha ancora indicato i suoi dati di fatturazione: si chiedono al momento della vendita.'
                                    : 'Lettura in corso…'}
                            </p>
                        )}
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default DatiAnagraficiPlayer;
